import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NbButtonModule, NbIconModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { ActionsFooterFilterPipe } from './action-footer-filter.pipe';
import { ActionsFooterService } from './actions-footer.service';

@Component({
	selector: 'app-actions-footer',
	styleUrls: ['./actions-footer.component.scss'],
	template: `@for (position of positions; track position) {
			<span>
				@for (
					action of actionsFooterService.actions
						| appActionsFooterFilter: position;
					track action
				) {
					<ng-container
						[ngTemplateOutlet]="actionTemplate"
						[ngTemplateOutletContext]="{ action: action }"
					></ng-container>
				}
			</span>
		}

		<ng-template #actionTemplate let-action="action">
			<button
				nbButton
				[title]="action.title || action.label | translate"
				role="button"
				[class]="action.class"
				[disabled]="action.disabled$ | async"
				[status]="action.status || 'primary'"
				[outline]="action.outline"
				(click)="action.click()"
			>
				@if (
					action.icon &&
					(action.icon?.position === 'left' ||
						action.icon.position === undefined)
				) {
					<nb-icon
						[icon]="action.icon.icon || action.icon"
						[pack]="action.icon.pack"
					></nb-icon>
				}
				{{ action.label | translate }}
				@if (action.icon && action.icon.position === 'right') {
					<nb-icon
						[icon]="action.icon.icon || action.icon"
						[pack]="action.icon.pack"
					></nb-icon>
				}
			</button>
		</ng-template>`,
	standalone: true,
	imports: [
		NgTemplateOutlet,
		NbButtonModule,
		NbIconModule,
		AsyncPipe,
		TranslateModule,
		ActionsFooterFilterPipe
	]
})
export class ActionsFooterComponent {
	/**
	 * SF20240715-FIXME
	 */
	positions: ('left' | 'center' | 'right')[] = ['left', 'center', 'right'];

	/**
	 * DI
	 */
	public actionsFooterService = inject(ActionsFooterService);
}
